import {useEffect} from 'react';
import {useLoading} from './LoadingContext';

const LoadingFallback=({progress=null})=>{
    const {showLoading,hideLoading}=useLoading();
    useEffect(()=>{
        showLoading(progress);
        return()=>hideLoading();
    },[hideLoading,progress,showLoading]);
    return null;
};
export default LoadingFallback;